// @flow
import type { FluxStandardAction } from 'modules/helper';
import { LocationActionTypes } from './actionTypes';
import type { LocationType } from 'types/common';

export type LocationState = {
  location: Object<LocationType> | null,
  loading: {
    location: boolean,
  },
  error: {
    location: string | null,
  },
};

const initialState: LocationState = {
  location: null,
  loading: {
    location: false,
  },
  error: {
    location: null,
  },
};

export const LocationReducer = (
  state: LocationState = initialState,
  action: FluxStandardAction
) => {
  const { type, payload, error } = action;

  switch (type) {
    // User Location
    case LocationActionTypes.LOCATION.FETCH:
      return {
        ...state,
        loading: { ...state.loading, location: true },
        error: { ...state.error, location: null },
      };
    case LocationActionTypes.LOCATION.SUCCESS:
      return {
        ...state,
        location: payload,
        loading: { ...state.loading, location: false },
      };
    case LocationActionTypes.LOCATION.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, location: false },
        error: { ...state.error, location: error },
      };
    default:
      return state;
  }
};
